import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-budget-cap-regional-table",
  templateUrl: "./budget-cap-regional-table.component.html",
  styleUrls: ["./budget-cap-regional-table.component.scss"],
})
export class BudgetCapRegionalTableComponent {
  @Input() item: any;
  @Input() regions: string[] = [];
  @Input() budgetCapAmtForRegions: any = {};
  @Output() moveToPreviousPageEvent = new EventEmitter<boolean>();
  @Output() moveToNextPageEvent = new EventEmitter<void>();

  americasRegions = ["USA", "CANADA", "LATAM"];

  getAmericasRegions() {
    return this.americasRegions.filter((r) => this.regions.includes(r));
  }

  getOtherRegions() {
    return this.regions.filter((r) => !this.americasRegions.includes(r));
  }

  getAmericasTotal() {
    return this.getAmericasRegions().reduce(
      (sum, r) => sum + (Number(this.budgetCapAmtForRegions[r]) || 0),
      0
    );
  }

  getAllRegionsTotal() {
    return this.regions.reduce(
      (sum, r) => sum + (Number(this.budgetCapAmtForRegions[r]) || 0),
      0
    );
  }

  hasOnlyAmericas() {
    const regions = this.regions || [];
    return regions.every((r) => this.americasRegions.includes(r));
  }

  checkBudgetRegionData() {
    if (
      Object.keys(this.budgetCapAmtForRegions).length &&
      Object.values(this.budgetCapAmtForRegions).some((x) => x == null)
    ) {
      return true;
    } else {
      return false;
    }
  }
}
